import { filterNotEmpty } from '@beeline.com/bp-design-system';
import { isProcessesDefinitionVisible, isProcessesInstanceVisible } from 'common/auth/Authorize';
import { NavItem } from 'common/HorizontalNavPage';
import { PermissionName } from '@utmost.co/enterprise-models';
import { useProcessesIntl } from './translations/useProcessesIntl';
import { useLoggedInUser } from 'src/utils/hooks/useLoggedInUser';

export enum PROCESSES_TAB {
  GENERAL = 'general',
  DEFINITIONS = 'definitions',
  INSTANCES = 'instances'
}

export function useAllowedProcessesNavItems(): NavItem[] {
  const user = useLoggedInUser();
  const isDefinitionVisible = isProcessesDefinitionVisible(user!);
  const isInstanceVisible = isProcessesInstanceVisible(user!);
  const intl = useProcessesIntl();

  return filterNotEmpty([
    {
      label: intl.general,
      path: PROCESSES_TAB.GENERAL,
      'data-test': 'general__settings__tab',
      permissions: [{ name: 'PROCESS', action: 'READ' }]
    },
    isDefinitionVisible && {
      label: intl.definitions,
      path: PROCESSES_TAB.DEFINITIONS,
      'data-test': 'definitions__settings__tab',
      permissions: [{ name: 'PROCESS_DEFINITION', action: 'READ' }]
    },
    isInstanceVisible && {
      label: intl.instances,
      path: PROCESSES_TAB.INSTANCES,
      'data-test': 'instances__settings__tab',
      permissions: [{ name: 'PROCESS', action: 'READ' }]
    }
  ]);
}

export const PERMISSION_ROUTE_MAP: Partial<PermissionMap> = {
  PROCESS_DEFINITION: PROCESSES_TAB.DEFINITIONS
};

type PermissionMap = {
  [E in PermissionName]: PROCESSES_TAB;
};
